import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import 'prop-types';

function SelectOption(_ref) {
  var children = _ref.children,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, ["children", "value"]);

  return /*#__PURE__*/React.createElement("option", _extends({
    value: value
  }, otherProps), children);
}

SelectOption.defaultProps = {
  children: null,
  value: ''
};

export default SelectOption;
